import styled, { css } from 'styled-components';
import { Flexer } from '@ontruck/orc';
import { Loading } from 'components/Loading';
import Select from 'components/Select';

export const StyledWrapper = styled(Flexer.Parent)``;

export const StyledAlert = styled(Flexer.Parent).attrs((props) => ({
  mTop: !props.first ? 'S' : '',
  pTop: !props.first ? 'S' : '',
}))`
  ${(props) =>
    (!props.first &&
      `
    border-top: 1px solid var(--greyMouse);
  `) ||
    ''}
`;

export const StyledLoadingContainer = styled(Flexer.Child)`
  position: relative;
  ${(props) =>
    props.loading
      ? `
    * {
      opacity: .4;
    }
  `
      : ''}
`;

export const StyledLoading = styled(Loading)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 1 !important;
`;

export const StyledSelect = styled(Select)`
  width: 220px;
`;

const titleProps = ({ theme }) => css`
  font-weight: bold;
  color: var(--grey900);
  background-color: var(--grey100);
  text-transform: uppercase;
  font-size: ${theme.base.textSizes.M};
`;

export const StyledTitle = styled(Flexer.Parent).attrs(() => ({
  p: 'S',
}))`
  ${titleProps}
`;
